import React from 'react';
import { colors } from '@moda/tokens';
import WarningIcon from '@moda/icons/warning-20';
import ExitIcon from '@moda/icons/exit-16';
import { Stack, Text, Clickable } from '@moda/om';
import { LineItem } from '../../../hooks/useCart/cart.rest';

type Props = {
  item: LineItem;
  onClearMovedAutomaticallyFlag: () => void;
};

export const LineItemMovedAutomaticallyMessage: React.FC<Props> = ({
  item: {
    type,
    attributes: { movedAutomatically, backInStock }
  },
  onClearMovedAutomaticallyFlag
}) => {
  if (type !== 'saved_items' || !movedAutomatically || backInStock) return null;

  return (
    <Stack
      data-test-id="line-item-moved-automatically-message"
      direction="horizontal"
      space={1}
      alignItems="center"
    >
      <WarningIcon color={colors.all['burnt-orange']} />
      <Text treatment="body2" color="burnt-orange">
        This item is no longer available, so we've moved it to your "Saved for Later" list.
      </Text>
      <Clickable aria-label="Hide" title="Hide" onClick={onClearMovedAutomaticallyFlag}>
        <ExitIcon color={colors.all['burnt-orange']} />
      </Clickable>
    </Stack>
  );
};
